import BlueStarBackgroundImage from "@/assets/images/blue-star-background-bold.png";
import { View } from "@/components/ui";
import { PackageListOverview } from "../package-list-overview";
import { CreditOverview } from "../credit-overview";
import { AccountOverview } from "../account-overview";
import { AccountProfileOverview } from "../account-profile-overview";
import { PushNotificationAlert } from "@/containers/notifications/push-notification-alert";
import { ImageBackground } from "@/components/ui/image-background";
import { useSafeAreaInsets } from "@/components/hooks/use-safe-area-insets";

export const Overview = () => {
  const { top } = useSafeAreaInsets();
  return (
    <View className="flex flex-col gap-4">
      <ImageBackground
        src={BlueStarBackgroundImage}
        style={{ paddingTop: top }}
      >
        <AccountProfileOverview />
        <PushNotificationAlert />
        <CreditOverview />
      </ImageBackground>
      <PackageListOverview />
      <AccountOverview />
    </View>
  );
};
